import runwayScorer from "./runwayScorer";

function runwaySorter(a, b) {
  return runwayScorer(a.properties.runway) - runwayScorer(b.properties.runway);
}

export default runwaySorter;
